import usePageView from '../../hooks/usePageView'
import usePageAction from '../../hooks/usePageAction'
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

const Analytics = props => {
  const [action, setAction] = useState({ type: '', event: '' });
  const { pathname } = useLocation();

  window.onclick = ev => setAction({
    type: ev.target.constructor.name,
    event: ev.target.innerText
  });

  usePageAction(action);
  usePageView(pathname);

  return null;
}

export const formatEvent = (ev) => (
  [ev]
    .map(p => unescape(p))
    .map(p => p.toLowerCase())
    .map(p => p.replace(/[^\w]/gi, ''))
    .pop()
);

export const trackEvent = (event) => {
  window.dellmetrics_pagenav && window.dellmetrics_pagenav('', event);
  console.log('trackEvent', event);
};

export const trackPage = page => {
  window.dellmetrics_pagenav && window.dellmetrics_pagenav(page);
}

export default Analytics;
